import Sortable from 'sortablejs';
import { createTodo, readTodo, reorderTodo, deleteTodo } from './response'
import { renderTodo } from './render';

const dateEl = document.querySelector('.date')
const formEl = document.querySelector('form')
const inputEl = formEl.querySelector('input')
const ulEl = document.querySelector('ul')
const delAllEl = document.querySelector('.options > button')
const noTodoEl = document.querySelector('.no-todo')
const loadingEl = document.querySelector('.loading')
const selectEl = document.getElementById('view-options')
const delModalEl = document.querySelector('.bg--blur')
const confirmDelAllBtn = delModalEl.querySelector('button.yes')
const rejectDelAllBtn = delModalEl.querySelector('button.no')
const closeDelModalBtn = delModalEl.querySelector('button.close')

rerender()
getDate()

//Todo 입력
formEl.addEventListener('submit',async (e) => {
  e.preventDefault();
  if(inputEl.value.trim().length < 1) return 

  await createTodo(inputEl.value.trim())
  if(selectEl.value === 'done') {selectEl.value = 'all'}
  rerender()

  inputEl.value = ''
  inputEl.focus()
});

// 일정 추가 버튼
noTodoEl.addEventListener('click',() => {
  inputEl.focus()
})

//보기 설정
selectEl.addEventListener('change', () => {
  rerender()
})

// 데이터 전체삭제
delAllEl.addEventListener('click', async () => {
  delModalEl.style.display = 'flex'

  // 확인버튼 클릭
  confirmDelAllBtn.addEventListener('click', async () => {
    loadingEl.style.display = 'block'

    const todos = await readTodo()

    todos.map((todo) => {
      deleteTodo(todo)
    })
    renderTodo([])

    delModalEl.style.display = 'none'
  })

  // 취소버튼 클릭
  rejectDelAllBtn.addEventListener('click', () => {
    delModalEl.style.display = 'none'
  })
})

// 모달 닫기버튼 클릭
closeDelModalBtn.addEventListener('click',() => {
  delModalEl.style.display = 'none'
})

// Todo 순서변경
new Sortable(ulEl, {
  animation: 150,
  onEnd: async function(e) {
    const liEls = e.to.children
    const todoIds = []
    for(let i = 0; i < liEls.length; i++) {
      todoIds.push(liEls[i].dataset.id)
    }
    await reorderTodo(todoIds)
    rerender();
  }
});

//Todo데이터 재요청,리렌더링
export function rerender(){
  loadingEl.style.display = 'block'
  readTodo().then(todos => renderTodo(todos))
}

//날짜정보
function getDate() {
  const date = new Date();

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  dateEl.textContent = `${year} 년 ${month} 월 ${day} 일`;
};